import React from "react";
import Circle from "../../assets/images/Circle.svg";
import "./alert-timeline-item.scss";
import PropTypes from "prop-types";

const AlertTimelineItemWithoutLine = props => (
  <div>
    {props.isWithoutLine && (
      <div className="cb-c-alert-timeline-item__status-change__date">
        <div style={{ height: "20px" }}>
          <img src={Circle} alt="Circle" height={20} width={20} />
        </div>
        <div className="fable:pl-4">{props.children}</div>
      </div>
    )}

    {!props.isWithoutLine && (
      <div>
        <div style={{ height: "20px" }}>
          <div className="cb-c-alert-timeline-item__status-change__icon__top">
            <svg height={35} width={15}>
              <line
                x1="2"
                y1="35"
                x2="2"
                y2="0"
                className="cb-c-alert-timeline-item__status-change__icon__top__line"
              />
            </svg>
          </div>

          <img src={Circle} alt="Circle" height={20} width={20} />
        </div>
        <div className="cb-c-alert-timeline-item__alert-raised">
          {props.children}
        </div>
      </div>
    )}
  </div>
);

AlertTimelineItemWithoutLine.propTypes = {
  isWithoutLine: PropTypes.bool
};

export default AlertTimelineItemWithoutLine;
